<nav class="navbar navbar-expand-lg navbar-light bg-white px-2 py-2">
  <div class="collapse navbar-collapse"
       id="navbarNavDropdown">
    <ul class="navbar-nav">
      <li class="nav-item"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link"
           routerLink="/mobile-dashboard"
           [ngClass]="isPage('mobile-dashboard') ? 'active': ''"> Dashboard</a>
      </li>
      <li class="nav-item dropdown"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link"
           aria-expanded="false"
           [ngClass]="isPage('orders')? 'active': ''"
           [routerLink]="['/agrishop', 'orders']">
          Orders
        </a>
      </li>
      <li class="nav-item"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link"
           routerLink="/agrishop"
           [ngClass]="isPage('agrishop') ? 'active': ''"> Input</a>
      </li>

      <li class="nav-item dropdown"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link dropdown-toggle"
           id="navbarDropdownMenuLink"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false">
          Services
        </a>
        <div class="dropdown-menu"
             aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item bg-white"
             routerLink="/services">Services</a>
          <a class="dropdown-item bg-white "
             routerLink="/services/orders">Service Orders</a>
        </div>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle"
           id="navbarDropdownMenuLink"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false"
           [ngClass]="isPage('mobile-pests') || isPage('mobile-diseases') ? 'active': ''">
          Diagnosis
        </a>
        <div class="dropdown-menu"
             aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item bg-white"
             routerLink="/mobile-diseases"
             [ngClass]="isPage('mobile-diseases') ? 'active': ''">Disease</a>
          <a class="dropdown-item bg-white "
             routerLink="/mobile-pests"
             [ngClass]="isPage('mobile-pests') ? 'active': ''">Pest</a>
          <a class="dropdown-item bg-white"
             href="#">Enquires</a>
        </div>
      </li>

      <li class="nav-item dropdown"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link dropdown-toggle"
           id="navbarDropdownMenuLink"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false"
           [ngClass]="isPage('mobile-pest-diseases') || isPage('mobile-smart-diseases') ? 'active': ''">
          Smart Diagnosis
        </a>
        <div class="dropdown-menu"
             aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item bg-white"
             routerLink="/mobile-smart-diseases"
             [ngClass]="isPage('mobile-smart-diseases') ? 'active': ''">Smart Disease</a>
          <a class="dropdown-item bg-white "
             routerLink="/mobile-pest-diseases"
             [ngClass]="isPage('mobile-pest-diseases') ? 'active': ''">Smart Pest</a>
        </div>
      </li>

      <li class="nav-item">
        <a class="nav-link"
           routerLink="/mobile-agronomical"
           [ngClass]="isPage('mobile-agronomical') ? 'active': ''"> Agronomical Info</a>
      </li>
      <li class="nav-item"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link"
           routerLink="/mobile-market-info"
           [ngClass]="isPage('mobile-market-info') ? 'active': ''"> Market-Info</a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" routerLink="/"> Weather</a>
      </li> -->
      <li class="nav-item"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link"
           routerLink="/"> Reports</a>
      </li>

      <li class="nav-item"
          *ngIf="countryName === 'Uganda'">
        <a class="nav-link"
           routerLink="/send-notifications"> Notifications</a>
      </li>
    </ul>
  </div>
</nav>
